import { Controller } from "@hotwired/stimulus"
import { MaskInput } from "maska"

export default class extends Controller {
    connect() {
        this.mask = new MaskInput(this.element)
    }

    disconnect() {
        if (this.mask) {
            this.mask.destroy()
        }
    }
}